import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Environment } from '@lib/classes';
import { AuthModule } from '@lib/core';
import { ButtonModule } from 'primeng/button';
import { Error404Component } from './error-404/error-404.component';
import { LayoutModule } from './layout/layout.module';
import { RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';
import { ACTIVE_BRAND_CONFIG, BRAND_CONFIG } from '../../brands';
import { TERMS_DISCLAIMER_URLS, TermsDisclaimerUrls } from '@lib/components';

/** Host serving the legal pages linked from the terms disclaimer. */
const LEGAL_BASE_URL = ACTIVE_BRAND_CONFIG.urls.main;

@NgModule({
  declarations: [Error404Component],
  imports: [
    CommonModule,
    AuthModule.forRoot(),
    LayoutModule,
    ButtonModule,
    RouterModule,
  ],
  providers: [
    {
      provide: Environment,
      useValue: environment,
    },
    {
      provide: BRAND_CONFIG,
      useValue: ACTIVE_BRAND_CONFIG,
    },
    {
      // Lets the shared terms disclaimer render brand-correct legal links without
      // every call site having to pass them in.
      provide: TERMS_DISCLAIMER_URLS,
      useValue: {
        main: ACTIVE_BRAND_CONFIG.urls.main,
        mainLabel: ACTIVE_BRAND_CONFIG.urls.main.replace(/^https?:\/\/(www\.)?/, ''),
        terms: `${LEGAL_BASE_URL}/terms-and-conditions`,
        refund: `${LEGAL_BASE_URL}/terms-and-conditions#refund`,
        privacy: `${LEGAL_BASE_URL}/privacy-policy`,
        ownDataSearches: `${LEGAL_BASE_URL}/searches-of-your-own-personal-data`,
        thirdPartySearches: `${LEGAL_BASE_URL}/searches-relating-to-third-parties`,
      } satisfies TermsDisclaimerUrls,
    },
  ],
})
export class CoreModule {}
